export default __webpack_public_path__ + "static/media/mentionAndEindex.73fe1433.png";